<template>
<v-dialog v-model="dialogCreateProject" persistent max-width="650" class="CSChatThai">
  <v-card>
    <v-card tile text>
      <v-toolbar text class="toolbar-card-v2">
        <v-toolbar-title class="CSChatThai">
          <v-icon color="black">fas fa-tasks</v-icon>&nbsp;&nbsp;{{$t('Task.allTask.createProject')}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon text @click="closeDialog">
          <v-icon style="color: black !important; font-size: 20px !important;">fa-solid fa-xmark</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <v-system-bar class="system-bar">  </v-system-bar> -->
    </v-card>
    <v-card-text class="CSChatThai" style="overflow-y: scroll; height: 50vh; justify-content: center; align-items: center;">
        <v-row class="justify-start align-start pa-10">
          <v-col cols="3" align="end" class="textSubject">
            <span>{{$t('Task.create.projectSubject')}}<span style="color: red;">*</span> :</span>
          </v-col>
          <v-col cols="9">
            <input type="text" :placeholder="$t('Task.create.placeholderSubjectProject')" class="CSChatThai inputtaskweb" v-model="subject_project">
          </v-col>
          <v-col cols="3" align="end" justify="start" class="textSubject">
            <span>{{$t('Task.create.description')}} :</span>
          </v-col>
          <v-col cols="9">
            <v-textarea
              :label="$t('Task.create.placeholderDescription')"
              no-resize
              style="width: 100%;"
              outlined
              height="80"
              rows=3
              :rules="[(v) => v.length <= 250 || '']"
              :counter="250"
              v-model="detail_project"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-layout row wrap align-center justify-center class="">
          <v-btn class="btncancle" @click="cancel_task()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          <v-btn class="btncreate" @click="create_project()" :loading="isloading"
          :disabled="subject_project == '' || detail_project.length > 250">{{$t('AnswerQuestion.ok')}}</v-btn>
        </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
import { Decode } from '@/services'
// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
var _ = require('lodash')
export default {
  props: {
    dialogCreateProject: false,
    projectid: ''
  },
  data: () => ({
    detail_project: '',
    token: '',
    subject_project: '',
    radios: '1',
    menu1: false,
    menu2: false,
    start_date: new Date().toISOString().substr(0, 10),
    end_date: new Date().toISOString().substr(0, 10),
    min_date: '',
    max_date: '',
    priority: '1',
    member: [],
    state: [],
    state_id: '',
    selectemember: [],
    subject_projectRules: [
      v => !!v || 'กรุณากรอกหัวข้อการ์ด',
    ],
    isloading: false,
    min_date_end: '',
    max_date_end: '',
    data_user: {},
    // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
  }),
  components: {
    // DateRangePicker
  },
  created () {
    // var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // this.token = decoded['tokenuser']
    var user_profile = ''
      if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.tokenuser = this.data_user.tokenuser
  },
  mounted () {
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    dialogCreateProject () {
      // console.log(this.dialogCreateTask)
      if (this.dialogCreateProject) {
        // this.getroom()
        // this.getstate()
      }
    }
  },
  methods: {
    closeDialog () {
      this.selectemember = []
      this.priority = '1'
      this.detail_project = ''
      this.subject_project = ''
      this.start_date = new Date().toISOString().substr(0, 10),
      this.end_date = new Date().toISOString().substr(0, 10),
      this.$emit('closeCreateProject', false)
    },
    cancel_task () {
      this.selectemember = []
      this.priority = '1'
      this.detail_project = ''
      this.subject_project = ''
      this.isloading = false
    },
    create_project () {
      this.isloading = true
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/create_project', {
        tokenuser: this.tokenuser,
        tokenroom: this.$route.params.tokenroom,
      	project_name: this.subject_project,
        detail: this.detail_project
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          this.isloading = false
          // this.$swal('','สร้างโปรเจคสำเร็จ', 'success')
          this.$swal({ title: this.$t('Alert.Success.createProject'), type: 'success' })
          this.$emit('createdproject', {'project_id': response.data.data._id, 'event': 'create_project'})
          this.closeDialog()
        }
      }).catch(error => {
        console.log(error.message)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-input .v-label {
  height: 25px !important;
  line-height: 24px !important;
}
>>>.v-text-field--outline .v-input__slot {
  min-height: 50px !important;
}
.system-bar {
  height: 3px !important;
  border-radius: 10px !important;
  width: 600px !important;
  margin-left: 55px !important;
  background-color: #d8d8d8 !important;
}
>>>.v-btn-toggle--selected {
  box-shadow: none !important;
}
.text-overflow-chip {
  margin-top: 10px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 50px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
}
.selectedPriority {
 border-radius: 5px;
 border: 1px solid #979797;
}
.btn-pri1 {
  /*width: 80px !important;*/
  color: #b3493d !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri2 {
  /*width: 80px !important;*/
  color: #fcbe55 !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri3 {
  /*width: 80px !important;*/
  color: #a0a1a3 !important;
  /*border-radius: 4px !important;*/
  font-size: 34px !important;
}
>>>.v-input__slot {
  border-radius: 6px !important;
  /* border-color: #949494 !important;
  border-style: solid !important;
  border-width: thin !important; */
  border-width: thin !important;
  box-shadow: none !important;
}
.height-600px {
  height: 600px !important;
}
.toolbar-card {
  background-color: #1e2227 !important;
}
.toolbar-card-v2 {
  background-color: white !important;
}
.btncreate {
  font-weight: 700;
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  /* background: #2562af !important; */
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  width: 90px !important;
  text-transform: none !important;
}
.btncancle {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #ffffff !important;
  color: #4268fb !important;
  width: 90px !important;
  border-style: solid !important;
  border-color: #4268fb !important;
  box-shadow: none !important;
  text-transform: none !important;
}
.text2 {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  font-size: 20px;
  /* ANSI X letter */
}

.containers {
  width: 454px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}
.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 135px !important;
  display: -webkit-inline-box !important;
  background: #f3f2f2 !important;
  padding-top: 17px !important;
  border-radius: 10px !important;
  margin-bottom: 15px !important;
  margin-top: 20px;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 140px !important;
  height: 100px !important;
  position: relative;
  background: white;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  /* background-image: url('/static/img/default_profile/group-white.png'); */
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
input[type=text]:focus {
    outline: none !important;
}
>>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
}
>>>.trix-content {
    height: 220px !important;
}
>>>trix-editor:empty:not(:focus)::before {
    content: attr(placeholder);
    color: #858585;
    font-size: 16px;
    cursor: text;
}
>>>.trix-button-group--file-tools {
  display: none;
}
.attachment_file {
  border-radius: 3px;
  border: #bbbbbb 1px solid;
  background: #eee;
  width: fit-content;
  padding-left: 5px;
  padding-right: 5px;
  display: inline-block;
}
>>>.inputtaskweb {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 100% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
}
.textSubject {
  margin-top:20px;
  text-align: right;
  padding-right: 20px;
  font-size: 16px;
}
input[type=text]:focus {
    outline: none !important;
}
textarea[type=text]:focus {
    outline: none !important;
}
.InputEdit {
    height: 43px;
    width: 100%;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    border: 1px #979797 solid;
}
</style>
